import { Trans, useTranslation } from "react-i18next";
import { createFileRoute } from "@tanstack/react-router";
import UserDetailsForm from "@/components/user/UserDetailsForm";
import { companyContactOptions, useCompanyContact, useUser } from "@/api";
import { useLoggedInUser, useRouterStore } from "@/store/zustandStore";

export const Route = createFileRoute("/_portal/settings/")({
  component: UserSettings,
  loader: () => {
    const { queryClient, user } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(companyContactOptions(user.buildingTenantId));
  },
});

function UserSettings() {
  const { t } = useTranslation();
  const currUser = useLoggedInUser();
  const { data: user } = useUser(currUser.userId);
  const { data: companyContact } = useCompanyContact(user.buildingTenantId);

  return (
    <>
      <div className="pageHeader">
        <h1>{t("PAGES.SETTINGS.HEADER")}</h1>
        <p>
          {t("PAGES.SETTINGS.SUBHEADER")}
          {companyContact && (
            <strong>
              {" "}
              <Trans
                i18nKey="YOUR_MAIN_ADMIN"
                values={{
                  companyContact: companyContact.name,
                }}
                components={{
                  mailto: <a href={`mailto:${companyContact.email}`}></a>,
                }}
              ></Trans>
            </strong>
          )}
        </p>
      </div>
      <UserDetailsForm key={JSON.stringify(user)} user={user} />
    </>
  );
}
